import { MAX_DAYS_PER_WEEK } from '@liza/fhir-utils';
import { Field, FieldContent, FieldGroup, FieldLabel } from '@liza/ui/components/ui/field';
import { ToggleGroup, ToggleGroupItem } from '@liza/ui/components/ui/toggle-group';
import { useTranslation } from 'react-i18next';

const COUNTS = Array.from({ length: MAX_DAYS_PER_WEEK }, (_, i) => i + 1);

/** Single-select 1×–7× quota picker for the days-per-week mode. */
export function DaysPerWeekCountField({
  count,
  onCountChange,
}: {
  count: number;
  onCountChange: (count: number) => void;
}): React.ReactNode {
  const { t } = useTranslation('common');
  return (
    <FieldGroup>
      <Field>
        <FieldLabel>{t('daysPerWeek')}</FieldLabel>
        <FieldContent>
          <ToggleGroup
            type="single"
            variant="outline"
            className="w-full"
            value={String(count)}
            onValueChange={(value) => {
              if (value) onCountChange(parseInt(value));
            }}
            aria-label={t('daysPerWeek')}
          >
            {COUNTS.map((n) => (
              <ToggleGroupItem key={n} value={String(n)} className="flex-1" data-testid={`days-per-week-${n}`}>
                {n}×
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </FieldContent>
      </Field>
    </FieldGroup>
  );
}
